import useSWR from "swr";
import { useSearchParams } from "react-router-dom";

import { useApiAccess } from "./useApiAccess";
import { apiRoutes } from "../../Constants/ApiRoutes";
import { getArticles } from "../../Service/ArticleService";

export const useCategoryArticles = ({ categorySlug }) => {

    const hasAccess = useApiAccess();
    const [ searchParams ] = useSearchParams();
    const productParam = searchParams.get('product');

    const pathParams = {
        sortBy: "rank",
        sort: "DESC",
        ...(productParam && { product: productParam })
      };

    const { data, ...rest } = useSWR(
        hasAccess ? `${apiRoutes.categories}${categorySlug}/${apiRoutes.getArticlesInCategory}${productParam}` : null,
        () => getArticles( categorySlug, pathParams)
    );

    return { data: data ?? [], ...rest };
}